import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _merge from "lodash/merge";
import _isPlainObject from "lodash/isPlainObject";
import "core-js/modules/es6.array.slice.js";
import "regenerator-runtime/runtime.js";
// eslint-disable-next-line max-classes-per-file
import { AnalyticsBrowser } from '@segment/analytics-next';
import config from '@nerdwallet/app-config';
import { getDeployableInfo } from "./utils";
export var SegmentLive = /*#__PURE__*/function () {
  function SegmentLive(analytics) {
    _classCallCheck(this, SegmentLive);

    this.analytics = analytics;
  } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


  _createClass(SegmentLive, [{
    key: "segmentInstance",
    get: function get() {
      return this.analytics;
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "page",
    value: function () {
      var _page = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$analytics;

        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (_this$analytics = this.analytics).page.apply(_this$analytics, _args);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function page() {
        return _page.apply(this, arguments);
      }

      return page;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "track",
    value: function () {
      var _track = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$analytics2;

        var _len,
            args,
            _key,
            event,
            properties,
            newArgs,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args2[_key];
                }

                event = args[0], properties = args[1];
                newArgs = args.slice(2); // Inject deployable info into the event properties

                if (_isPlainObject(event)) {
                  event = _merge({}, {
                    properties: getDeployableInfo()
                  }, event);
                } else {
                  properties = _merge({}, getDeployableInfo(), properties);
                }

                (_this$analytics2 = this.analytics).track.apply(_this$analytics2, [event, properties].concat(_toConsumableArray(newArgs)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function track() {
        return _track.apply(this, arguments);
      }

      return track;
    }()
  }, {
    key: "trackLink",
    value: function () {
      var _trackLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _len2,
            args,
            _key2,
            elem,
            event,
            properties,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (_len2 = _args3.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args3[_key2];
                }

                elem = args[0], event = args[1];
                properties = args[2]; // Inject deployable info into the event properties

                if (_isPlainObject(properties)) {
                  properties = _merge({}, getDeployableInfo(), properties);
                }

                this.analytics.trackLink(elem, event, properties);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function trackLink() {
        return _trackLink.apply(this, arguments);
      }

      return trackLink;
    }()
  }]);

  return SegmentLive;
}();
export var SegmentMock = /*#__PURE__*/function () {
  function SegmentMock() {
    _classCallCheck(this, SegmentMock);
  }

  _createClass(SegmentMock, [{
    key: "page",
    value: // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, class-methods-use-this
    function () {
      var _page2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _console;

        var _len3,
            args,
            _key3,
            _args4 = arguments;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (_len3 = _args4.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  args[_key3] = _args4[_key3];
                }

                (_console = console).log.apply(_console, ['ANALYTICS PAGE_VIEW'].concat(args));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function page() {
        return _page2.apply(this, arguments);
      }

      return page;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, class-methods-use-this

  }, {
    key: "track",
    value: function () {
      var _track2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _console2;

        var _len4,
            args,
            _key4,
            _args5 = arguments;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (_len4 = _args5.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  args[_key4] = _args5[_key4];
                }

                (_console2 = console).log.apply(_console2, ['ANALYTICS TRACK'].concat(args));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function track() {
        return _track2.apply(this, arguments);
      }

      return track;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, class-methods-use-this

  }, {
    key: "trackLink",
    value: function () {
      var _trackLink2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _console3;

        var _len5,
            args,
            _key5,
            _args6 = arguments;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (_len5 = _args6.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = _args6[_key5];
                }

                (_console3 = console).log.apply(_console3, ['ANALYTICS TRACK LINK'].concat(args));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function trackLink() {
        return _trackLink2.apply(this, arguments);
      }

      return trackLink;
    }()
  }]);

  return SegmentMock;
}();
export var initializeSegment = function initializeSegment() {
  var _config$SEGMENT;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;

  if (debug) {
    return new SegmentMock();
  }

  var writeKey = config === null || config === void 0 ? void 0 : (_config$SEGMENT = config.SEGMENT) === null || _config$SEGMENT === void 0 ? void 0 : _config$SEGMENT.WRITE_KEY;

  if (!writeKey || typeof window === 'undefined') {
    return new SegmentMock();
  }

  var browserAnalytics = AnalyticsBrowser.load({
    writeKey: writeKey,
    cdnURL: 'https://siteusagetools.nerdwallet.com'
  }, {
    integrations: {
      'Segment.io': {
        apiHost: 'siteusage.nerdwallet.com/v1',
        protocol: 'https'
      }
    }
  });
  return new SegmentLive(browserAnalytics);
};